module.exports = __webpack_public_path__ + "static/img/13.670fd7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/13.jpg
// module id = QtSU
// module chunks = 1